import { gql } from "@apollo/client";

export const GET_ROLES_QUERY_NAME = "GetGroups";
export const GET_ROLES_QUERY = gql`
  query ${GET_ROLES_QUERY_NAME} {
    system {
      user_settings {
        groups {
          id
          name
        }
      }
    }
  }
`;

export const CREATE_ROLE_MUTATION = gql`
  mutation CreateGroupMutation($name: String!) {
    create_group(name: $name) {
      success
      message
    }
  }
`;

export const DELETE_ROLE_MUTATION = gql`
  mutation DeleteGroupMutation($ids: [Int!]!) {
    delete_group(ids: $ids) {
      success
      message
    }
  }
`;

export const GET_ROLE_PERMISSIONS_QUERY_NAME = "GetGroupPermissions";
export const GET_ROLE_PERMISSIONS_QUERY = gql`
  query ${GET_ROLE_PERMISSIONS_QUERY_NAME}($group_id: Int!) {
    system {
      user_settings {
        group_permissions(group_id: $group_id) {
          permission_subtype {
            name
            codename
            checked
          }
          permission_type
        }
      }
    }
  }
`;

export const UPDATE_ROLE_PERMISSIONS = gql`
  mutation UpdateGroupPermission(
    $id_group: ID!
    $permissions: [InputPermission]!
  ) {
    update_permissions(id_group: $id_group, permissions: $permissions) {
      success
      message
    }
  }
`;

export const GET_USERS_QUERY_NAME = "GetUsers";
export const GET_USERS_QUERY = gql`
  query ${GET_USERS_QUERY_NAME} {
  system {
    user_settings {
      users {
        first_name
        is_current
        is_superuser
        last_name
        username
        id
        email
        groups {
          name
        }
      }
    }
  }
}
`;

export const CREATE_USER_MUTATION = gql`
  mutation CreateUser(
    $email: String!
    $first_name: String!
    $groupname: String!
    $last_name: String!
    $password: String!
    $username: String!
  ) {
    create_user(
      email: $email
      first_name: $first_name
      groupname: $groupname
      last_name: $last_name
      password: $password
      username: $username
    ) {
      success
      message
    }
  }
`;

export const UPDATE_USER_MUTATION = gql`
  mutation UpdateUser(
    $email: String!
    $first_name: String!
    $groupname: String
    $last_name: String!
    $username: String!
    $password: String
  ) {
    update_user(
      email: $email
      first_name: $first_name
      groupname: $groupname
      last_name: $last_name
      password: $password
      username: $username
    ) {
      success
      message
    }
  }
`;

export const DELETE_USER_MUTATION = gql`
  mutation DeleteUser($ids: [Int!]!) {
    delete_user(user_ids: $ids) {
      success
      message
    }
  }
`;

export const READ_TLS_SETTINGS_NAME = "ReadTlsSettings";
export const READ_TLS_SETTINGS_QUERY = gql`
  query ${READ_TLS_SETTINGS_NAME} {
    system {
      certificates {
        meta
        type
      }
    }
  }
`;

export const UPDATE_HTTPS_CERTIFICATE = gql`
  mutation UpdateHttpsCertificate(
    $cert: Upload!
    $key: Upload!
    $pass_phrase: String
  ) {
    update_https_cert_files(cert: $cert, key: $key, pass_phrase: $pass_phrase) {
      success
      message
    }
  }
`;

export const UPDATE_FTPS_CERTIFICATE = gql`
  mutation UpdateHttpsCertificate(
    $cert: Upload!
    $key: Upload!
    $pass_phrase: String
  ) {
    update_ftps_cert_files(cert: $cert, key: $key, pass_phrase: $pass_phrase) {
      success
      message
    }
  }
`;

export const UPDATE_LICENSE_CERTIFICATE = gql`
  mutation UpdateLicenseCertificate(
    $expiration_date: String!
    $hostname: String!
  ) {
    update_license_cert_files(
      expiration_date: $expiration_date
      hostname: $hostname
    ) {
      success
      message
    }
  }
`;

export const CREATE_OTA_CERTIFICATE = gql`
  mutation CreateOtaCertificate($cert: Upload!) {
    create_ota_cert_files(cert: $cert) {
      success
      message
    }
  }
`;

export const DELETE_OTA_CERTIFICATE = gql`
  mutation DeleteOtaCertificate {
    delete_ota_cert_file {
      success
      message
    }
  }
`;

export const READ_REPO_INFO_QUERY_NAME = "ReadRepoInfo";
export const READ_REPO_INFO_QUERY = gql`
  query ${READ_REPO_INFO_QUERY_NAME} {
  system {
      server_info
    }
  }
`;

export const READ_SYSTEM_EVENTS_QUERY = gql`
  query SystemEventsQuery {
    system {
      system_events {
        timestamp
        template
        params
        event_type
        resource_metadata
        id_sys_event
      }
    }
  }
`;

export const READ_SERVICES_QUERY_NAME = "ReadServices";
export const READ_SERVICES_QUERY = gql`
  query ${READ_SERVICES_QUERY_NAME} {
    system {
      services {
        type
        name
        enabled
        status
        status_message
        properties
      }
    }
  }
`;

export const UPDATE_BILLING_URL_MUTATION = gql`
  mutation UpdateBillingURL($url: String!) {
    update_billing_proxy_url(url: $url) {
      message
      success
    }
  }
`;

export const CREATE_BILLING_CERTIFICATE_MUTATION = gql`
  mutation CreateBillingCertificate($cert: Upload!, $key: Upload!) {
    create_billing_proxy_certificate(cert: $cert, key: $key) {
      message
      success
    }
  }
`;

export const DELETE_BILLING_CERTIFICATE_MUTATION = gql`
  mutation DeleteBillingCertificate {
    delete_billing_proxy_certificate {
      message
      success
    }
  }
`;

export const ENABLE_SERVICE_MUTATION = gql`
  mutation EnableService($service_type: ServiceEnum!) {
    enable_service(service_type: $service_type) {
      message
      success
    }
  }
`;

export const DISABLE_SERVICE_MUTATION = gql`
  mutation DisableService($service_type: ServiceEnum!) {
    disable_service(service_type: $service_type) {
      message
      success
    }
  }
`;

const OKTA_FRAGMENT = gql`
  fragment OktaFragment on ServerSettings {
    okta {
      app_id
      app_secret
      auth_server_audience
      auth_server_id
      org_domain
      enabled
      redirect_uri
    }
  }
`;

const SMTP_FRAGMENT = gql`
  fragment SmtpFragment on ServerSettings {
    smtp {
      from_addr
      smtp_login
      smtp_server
      smtp_port
      smtp_pass
      to_addr
    }
  }
`;

const ACTION_LOG_FRAGMENT = gql`
  fragment ActionLogFragment on ServerSettings {
    action_log {
      rotation_years
    }
  }
`;

const FTP_FRAGMENT = gql`
  fragment FtpFragment on ServerSettings {
    proftpd {
      masquerade_address
    }
  }
`;

export const READ_SERVER_SETTINGS_QUERY = gql`
  ${OKTA_FRAGMENT}
  ${SMTP_FRAGMENT}
  ${ACTION_LOG_FRAGMENT}
  ${FTP_FRAGMENT}
  query ReadServerSettings {
    system {
      server_settings {
        ...OktaFragment
        ...SmtpFragment
        ...ActionLogFragment
        ...FtpFragment
      }
    }
  }
`;

export const UPDATE_OKTA_SETTINGS = gql`
  mutation UpdateOktaSettings(
    $app_id: String!
    $auth_server_audience: String!
    $auth_server_id: String!
    $org_domain: String!
    $enabled: Boolean
    $app_secret: String
    $redirect_uri: String
  ) {
    update_okta_settings(
      app_id: $app_id
      auth_server_audience: $auth_server_audience
      auth_server_id: $auth_server_id
      org_domain: $org_domain
      enabled: $enabled
      app_secret: $app_secret
      redirect_uri: $redirect_uri
    ) {
      message
      success
    }
  }
`;

export const UPDATE_SMTP_SETTINGS = gql`
  mutation UpdateSmtpSettings(
    $from_addr: String!
    $smtp_login: String!
    $smtp_port: Int!
    $smtp_server: String!
    $to_addr: String!
    $smtp_pass: String
  ) {
    update_smtp_settings(
      from_addr: $from_addr
      smtp_login: $smtp_login
      smtp_port: $smtp_port
      smtp_server: $smtp_server
      to_addr: $to_addr
      smtp_pass: $smtp_pass
    ) {
      message
      success
    }
  }
`;

export const UPDATE_ACTION_LOG_SETTINGS = gql`
  mutation UpdateActionLogSettings($rotation_period: Int!) {
    update_action_log_period(rotation_period: $rotation_period) {
      message
      success
    }
  }
`;

export const UPDATE_FTP_SETTINGS = gql`
  mutation UpdateFtpSettings($masquerade_address: String!) {
    update_ftp_masquerade_address(masquerade_address: $masquerade_address) {
      message
      success
    }
  }
`;
